module.exports = __webpack_public_path__ + "static/media/567.38484aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/vehicleDetail/images/567.png
// module id = 776
// module chunks = 0